import { Modal, Space, Table, Tooltip, Input, Popconfirm, Select, Button } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  UnorderedListOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { openNotification } from "../../functions";

const { Option } = Select;

class SalesPoints extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRole: false,
      clientName: "",
      salesPoints: [],
      editPoint: false,
      pointModal: false,
      point_address: "",
      point_name: "",
      editPoint_id: 0,
    };
    this.customNavFunction = this.customNavFunction.bind(this);
  }

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  customNavFunction() {
    return this.props.navigate("/");
  }

  setRole(rec) {
    this.setState({
      modalRole: true,
      clientName: rec.name + "/" + rec.tgName,
    });
  }

  getPoints() {
    fetch(`https://bot.weddingchelny.ru/api/adm/sales-points`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ salesPoints: res.data, editPoint: false });
        }
      }
    });
  }

  ChangeInputValue = (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value, inputChanged: true });
  };

  savePoint() {
    if (this.state.point_name.trim() == "" || this.state.point_address.trim() == "") {
      return openNotification("Ошибка", 'Поля "Имя" и "Адрес" должны быть заполнены', 1, 3.0);
    }
    fetch(
      this.state.editPoint == true
        ? `https://bot.weddingchelny.ru/api/adm/sales-points/` + this.state.editPoint_id
        : `https://bot.weddingchelny.ru/api/adm/sales-points/`,
      {
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("ttk"),
        }),
        method: this.state.editPoint == true ? "PATCH" : "POST",
        body: JSON.stringify({
          name: this.state.point_name,
          address: this.state.point_address,
        }),
      }
    ).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            pointModal: false,
            point_name: "",
            point_address: "",
          });
          this.getPoints();
        }
      }
    });
  }

  changeStatus(id, status) {
    fetch(`https://bot.weddingchelny.ru/api/adm/sales-points/` + id + `/status`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "PATCH",
      body: JSON.stringify({
        status: status,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.getPoints();
        }
      }
    });
  }

  render() {
    const data = [
      {
        key: "1",
        name: "Точка 1",
        address: "улица Пушкина, дом Колотушкина",
        ban: 0,
      },
      {
        key: "2",
        name: "Точка на рынке",
        address: "улица Простая, дом 19",
        ban: 1,
      },
    ];

    const columns = [
      {
        title: "Название",
        dataIndex: "sp_name",
        key: "sp_name",
      },
      {
        title: "Адрес",
        dataIndex: "sp_address",
        key: "sp_address",
      },
      {
        title: "Действия",
        dataIndex: "events",
        key: "events",
        render: (text, record) => {
          return (
            <Space size="large">
              <Tooltip title="Изменить">
                <EditOutlined
                  onClick={() => {
                    this.setState({
                      editPoint: true,
                      point_name: record.sp_name,
                      point_address: record.sp_address,
                      pointModal: true,
                      editPoint_id: record.key,
                    });
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
              {record.sp_status == 1 ? (
                <Popconfirm
                  title="Защита от случайного нажатия"
                  description="Вы действительно хотите отключить точку продаж?"
                  onConfirm={() => {
                    this.changeStatus(record.key, 0);
                  }}
                  onCancel={() => { }}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Tooltip title="Точка активна">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Защита от случайного нажатия"
                  description="Вы действительно хотите включить точку продаж?"
                  onConfirm={() => {
                    this.changeStatus(record.key, 1);
                  }}
                  onCancel={() => { }}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Tooltip title="Точка заблокирована">
                    <CloseCircleTwoTone twoToneColor="#eb2f96" />
                  </Tooltip>
                </Popconfirm>
              )}
            </Space>
          );
        },
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space>
            <h1>Точки продаж</h1>
            <Button
              onClick={() => {
                this.setState({
                  editPoint: false,
                  point_name: "",
                  point_address: "",
                  pointModal: true,
                  editPoint_id: 0,
                });
              }}
              type="primary"
            >
              Создать точку продаж
            </Button>
          </Space>
          <Table columns={columns} dataSource={this.state.salesPoints} />
          <Modal
            title={"Точка продаж"}
            open={this.state.pointModal}
            onOk={() => {
              this.savePoint(0);
            }}
            onCancel={() => {
              this.setState({ editPoint: false, point_name: "", point_address: "", pointModal: false });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <div>Название</div>
                <Input name="point_name" value={this.state.point_name} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Адрес</div>
                <Input
                  name="point_address"
                  value={this.state.point_address}
                  onChange={this.ChangeInputValue.bind(this)}
                />
              </div>
            </Space>
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getPoints();
  }
}

export default withRouter(SalesPoints);
